export default __webpack_public_path__ + "static/media/lv8.caab6289.png";